import { useState, useEffect, useRef } from "react";
import { Html } from "@react-three/drei";
import { Vector3 } from 'three';
import './HotspotButton.scss';

export default function Hotspot({ 
    position, 
    onClick, 
    data, 
    isEditMode = false,
    hotspotId,
    onPositionUpdate
}) {
    const [showInputs, setShowInputs] = useState(false);
    const [editPos, setEditPos] = useState({ x: 0, y: 0, z: 0 });
    const isManualEditRef = useRef(false);

    useEffect(() => {
        if (isManualEditRef.current) {
            isManualEditRef.current = false;
            return;
        }
        
        if (position) {
            setEditPos({ x: position.x, y: position.y, z: position.z });
        }
    }, [position]);

    const handleClick = (e) => {
        if (isEditMode) {
            e.stopPropagation();
            setShowInputs(!showInputs);
        } else if (onClick) {
            onClick();
        }
    };

    const handlePositionChange = (axis, value) => {
        const newValue = parseFloat(value) || 0;
        const newPos = { ...editPos, [axis]: newValue };
        
        setEditPos(newPos);
        isManualEditRef.current = true;        
        if (onPositionUpdate) {
            onPositionUpdate(hotspotId, new Vector3(newPos.x, newPos.y, newPos.z));
        }
    };

    const currentPosition = position;

    return (
        <Html 
            position={currentPosition} 
            center
            style={{ pointerEvents: 'auto' }}
        >
            <div style={{ position: 'relative', display: 'inline-block' }}>
                <button 
                    onClick={handleClick}
                    className={`hotspot-button ${isEditMode ? 'hotspot-button--editable' : ''} ${showInputs ? 'hotspot-button--selected' : ''}`}
                    style={{ 
                        cursor: isEditMode ? 'pointer' : 'pointer',
                        userSelect: 'none'
                    }}
                >
                    <span className="hotspot-button-dot"></span> 
                    {data.title}
                    {isEditMode && <span style={{ marginLeft: '8px', fontSize: '10px', opacity: 0.7 }}>(edit)</span>}
                </button>
                
                {isEditMode && showInputs && (
                    <div className="hotspot-edit-inputs">
                        <div className="hotspot-edit-inputs__group">
                            <label className="hotspot-edit-inputs__label">X:</label>
                            <input
                                type="number"
                                value={editPos.x.toFixed(2)}
                                onChange={(e) => handlePositionChange('x', e.target.value)}
                                step="1"
                                className="hotspot-edit-inputs__input"
                            />
                        </div>
                        <div className="hotspot-edit-inputs__group">
                            <label className="hotspot-edit-inputs__label">Y:</label>
                            <input
                                type="number"
                                value={editPos.y.toFixed(2)}
                                onChange={(e) => handlePositionChange('y', e.target.value)}
                                step="1"
                                className="hotspot-edit-inputs__input"
                            />
                        </div>
                        <div className="hotspot-edit-inputs__group">
                            <label className="hotspot-edit-inputs__label">Z:</label>
                            <input
                                type="number"
                                value={editPos.z.toFixed(2)}
                                onChange={(e) => handlePositionChange('z', e.target.value)}
                                step="1"
                                className="hotspot-edit-inputs__input"
                            />
                        </div>
                    </div>
                )}
            </div>
        </Html>
    );
}
